import {mergeStyles} from '../../../../@react-spectrum/s2/style/runtime';
import React from 'react';
import {style, StyleString} from '@react-spectrum/s2/style' with {type: 'macro'};

export const ReactAriaLogo = ({styles}: {styles?: StyleString}) => {
  return (
    <svg
      className={mergeStyles(style({size: 24, flexShrink: 0, display: 'block'}), styles)}
      viewBox="200 206 800 790"
      fill="none">
      <path
        d="M720.67 205.995C867.583 205.995 986.679 325.091 986.68 472.003C986.68 590.753 908.865 691.325 801.446 725.521L979.312 948.055C994.438 966.98 980.963 995 956.736 995H795.612C778.743 995 762.715 987.629 751.734 974.823L697.365 911.421L493.126 653.39C457.134 607.918 489.518 540.979 547.511 540.977L720.67 540.971C758.758 540.971 789.635 510.091 789.635 472.003C789.634 433.915 758.758 403.038 720.67 403.038H429.939C404.955 403.038 388.623 391.886 373.994 373.623L277.349 252.966C262.194 234.045 275.664 205.996 299.905 205.995H720.67Z M396.605 720.706C407.798 705.406 430.443 704.843 442.381 719.568L503.816 797.018H502.786L535.569 838.934C548.074 854.358 549.943 877.191 538.047 893.09L476.638 972.545C465.692 986.707 448.803 995 430.903 995H242.276C218.18 995 204.665 967.248 219.523 948.278L337.992 797.018H337.923L396.605 720.706Z"
        fill="light-dark(#6733FF, #7F57FF)"
      />
    </svg>
  );
};
